import { addMessages } from '@hana/i18n';

// Khoá sgp.* — màn ServiceGP. Mã nghiệp vụ (REV, BIL, ABS, OBH, COL, GP) không dịch.
addMessages('vi', {
  'sgp.m10': "Tháng 10",
  'sgp.m09': "Tháng 9",
  'sgp.rng': "Khoảng ngày",
  'sgp.svc': "Dịch vụ",
  'sgp.pic': "Người phụ trách",
  'sgp.nowrite': "Chưa mở ghi ở bản này",
  'sgp.m10y': "Tháng 10/2026",
  'sgp.m09y': "Tháng 9/2026",
  'sgp.tipRev': "Doanh thu · HĐ HANA · ghi nhận trong kỳ",
  'sgp.tipGp': "Không tính OBH, COL",
  'sgp.tipGpp': "GP / doanh thu",
  'sgp.kDev': "Lệch dự kiến",
  'sgp.tipDev': "Chi phí so dự kiến",
  'sgp.kTreo': "OBH · COL chưa cân",
  'sgp.tipObh': "chưa đòi lại khách",
  'sgp.tipCol': "chưa chuyển trả",
  'sgp.title': "GP theo dịch vụ",
  'sgp.tipWaitHead': "Phát sinh chờ trưởng bộ phận duyệt",
  'sgp.waitL': "chờ duyệt",
  'sgp.groupBy': "Gom theo",
  'sgp.hub': "Service Hub mở ở vùng Dịch vụ",
  'sgp.period': "Kỳ ghi nhận",
  'sgp.fromT': "Từ ngày hoàn thành",
  'sgp.toT': "Đến ngày hoàn thành",
  'sgp.from': "Từ ngày",
  'sgp.to': "Đến ngày",
  'sgp.perT': "Kỳ ghi nhận = ngày hoàn thành dịch vụ",
  'sgp.noperm': "Không có quyền xem GP dịch vụ.",
  'sgp.view': "Xem job",
  'sgp.devC': "Lệch chi phí",
  'sgp.devHead': "có dòng cần trưởng bộ phận duyệt",
  'sgp.devT': "Lệch chi phí so dự kiến",
  'sgp.dev': "Lệch",
  'sgp.tipWait': "Phát sinh chờ duyệt",
  'sgp.unbal': "chưa cân",
  'sgp.bal': "đã cân",
  'sgp.gpBy': "GP theo",
  'sgp.close': "Đóng",
  'sgp.recT': "Ghi nhận (ngày hoàn thành dịch vụ)",
});
addMessages('en', {
  'sgp.m10': "October",
  'sgp.m09': "September",
  'sgp.rng': "Date range",
  'sgp.svc': "Service",
  'sgp.pic': "Owner",
  'sgp.nowrite': "Writing is not enabled in this build",
  'sgp.m10y': "October 2026",
  'sgp.m09y': "September 2026",
  'sgp.tipRev': "Revenue · HANA invoices · recognised in period",
  'sgp.tipGp': "Excludes OBH, COL",
  'sgp.tipGpp': "GP / revenue",
  'sgp.kDev': "Variance vs plan",
  'sgp.tipDev': "Cost vs plan",
  'sgp.kTreo': "OBH · COL unbalanced",
  'sgp.tipObh': "not yet recovered from customer",
  'sgp.tipCol': "not yet remitted",
  'sgp.title': "GP by service",
  'sgp.tipWaitHead': "Extra costs awaiting department head approval",
  'sgp.waitL': "pending",
  'sgp.groupBy': "Group by",
  'sgp.hub': "Service Hub opens in the Services zone",
  'sgp.period': "Recognition period",
  'sgp.fromT': "From completion date",
  'sgp.toT': "To completion date",
  'sgp.from': "From",
  'sgp.to': "To",
  'sgp.perT': "Period = service completion date",
  'sgp.noperm': "You do not have permission to view service GP.",
  'sgp.view': "View jobs",
  'sgp.devC': "Cost variance",
  'sgp.devHead': "lines need department head approval",
  'sgp.devT': "Cost variance vs plan",
  'sgp.dev': "Var.",
  'sgp.tipWait': "Extra costs pending approval",
  'sgp.unbal': "unbalanced",
  'sgp.bal': "balanced",
  'sgp.gpBy': "GP by",
  'sgp.close': "Close",
  'sgp.recT': "Recognised (service completion date)",
});
